<div class='ContactsSearch'>
  <div class='Breadcrumbs mt-3 mb-5'>
    <div class='Breadcrumbs-items'>
      <a [routerLink]='["/user_contacts", "user_groups"]'
      >
        <mat-icon class='Breadcrumbs-icon back'
        >keyboard_backspace
        </mat-icon
        >
      </a
      >
      <a [routerLink]='["/user_contacts", "user_groups"]' class='Breadcrumbs-item first'>Groups</a>
    </div>
  </div>
  <app-table
    #tableComponent
    *ngIf='tableReady'
    [columns]='tableColumns'
    [dataSourceParams]='tableDataSourceParams'
    [dataSource]='dataSource'
    [filterGroups]='tableFiltersGroups'
    [useRouteNavigation]='false'>
    <ng-template [appTableMobileRow] let-currentUser='currentUser' let-row='row'>
      <app-contacts-listing-mobile-row (activity)='openActivityDialog($event)' (vip)='toggleContactVip($event)'
                                       [item]='row'></app-contacts-listing-mobile-row>
    </ng-template>
  </app-table>
</div>
